export default __webpack_public_path__ + "static/media/7.50b0431d.svg";